import { FunctionalComponent, h } from "preact";
import style from "./style.scss";
import WhiteLogo from "../../assets/images/logo_white.svg";
import { Link } from "preact-router";
import { JSXInternal } from "preact/src/jsx";
type CSSProperties = JSXInternal.CSSProperties;

const Header = ({
  children,
  dark,
  innerRef,
  onHeaderClick,
  style: _style = {},
}: {
  children?: any;
  dark?: boolean;
  innerRef?: any;
  onHeaderClick?: () => void;
  style?: CSSProperties;
}) => {
  return (
    <header
      style={_style}
      class={[style.header, dark ? style.dark : ""].join(" ")}
      ref={innerRef}
    >
      <Link
        href="/"
        onClick={onHeaderClick}
        className={style["logo"]}
        style={{
          maskImage: `url(${WhiteLogo})`,
          "-webkit-mask-image": `url(${WhiteLogo})`,
        }}
      />
      <nav>{children}</nav>
    </header>
  );
};

export default Header;
